import { Images } from "../../../Images";
import OreCalculationLogic from "../../../logic/OreCalculationLogic";
import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import GridTile from "../../grid/GridTile";
import BigNum from "../../math/BigNum";
import StatisticsIncrementor from "../../statistics/StatisticsIncrementor";
import MinedOreUpgrade from "./MinedOreUpgrade";
import MinedUpgradeCreator from "./MinedUpgradeCreator";
import { UpgadeCreatorIds } from "./UpgradeCreatorIds";

export default class MinedOreBonusUpgradeCreator extends MinedUpgradeCreator {
    /**
     * @param {Values} values 
     * @param {OreCalculationLogic} oreCalculationLogic
     * @param {Totals} totals
     * @param {StatisticsIncrementor} statisticsIncrementor
     */
    constructor(values, oreCalculationLogic, totals, statisticsIncrementor) {
        super(UpgadeCreatorIds.mineOre, values, null);

        /**
         * @constant
         * @type {OreCalculationLogic}
         */
        this.oreCalculationLogic = oreCalculationLogic;
        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {StatisticsIncrementor}
         */
        this.statisticsInc = statisticsIncrementor;
    }

    /**
     * @param {GridTile} tile
     * @returns {Upgrade}
     */
    createMinedUpgrade(tile) {

        // Multiply the ore by the tile row
        const tileOre = new BigNum(0);

        this.oreCalculationLogic.calculateOreForDepth(tile, tileOre);

        let tilesPerUpgrade = Settings.skill.bonus.minedOreBaseTiles; // 8 tiles worth of ore

        // I'm pretty sure we do not have an upgrade anywhere in the game that affects this.
        const minedOreBonusUpgrades = this.values.skillMinedOreBonusUpgrades.getValue();
        if (minedOreBonusUpgrades > 0) {
            const extraTiles = minedOreBonusUpgrades * Settings.skill.bonus.minedOreBonusPerUpgrade;
            tilesPerUpgrade += extraTiles;
        }

        tileOre.mulNumber(tilesPerUpgrade);

        return this.createInternal(tileOre);
    }

    /**
     * @override
     * @param {BigNum} ore
     * @returns {Upgrade}
     */
    createFreeValueUpgradeFromSave(ore) {
        return this.createInternal(ore);
    }

    /**
     * @private
     * @param {BigNum} ore
     * @returns {Upgrade}
     */
    createInternal(ore) {
        const title = this.createTitle(ore);
        return new MinedOreUpgrade(this, title, Images.pick, ore, this.totals, this.statisticsInc);
    }

    /**
     * @override
     * @param {MinedOreUpgrade} upgrade1
     * @param {MinedOreUpgrade} upgrade2
     */
    combineUpgradesInternal(upgrade1, upgrade2) {
        // All we need to do is to add the valueDelta values.
        upgrade1.ore.add(upgrade2.ore);
        upgrade1.title = this.createTitle(upgrade1.ore);
    }

    /**
     * @private
     * @param {BigNum} ore 
     * @returns {string}
     */
    createTitle(ore) {
        return 'Ore: +' + NumberFormatter.formatBigNum(ore);
    }
}